import { render } from "./CrashHistory.vue?vue&type=template&id=378b42cb&scoped=true"
import script from "./CrashHistory.vue?vue&type=script&lang=js"
export * from "./CrashHistory.vue?vue&type=script&lang=js"

import "./CrashHistory.vue?vue&type=style&index=0&id=378b42cb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-378b42cb"]])

export default __exports__